import * as React from "react";

function SvgCwdCardDeadStock(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M20.942 13.018a9 9 0 10-7.909 7.922M12 7v5l2 2M17 17v5M21 17v5" /></svg>;
}

export default SvgCwdCardDeadStock;